import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/recommended-station.css";
import Station from "../Station.js";
import { GET_BROADCASTERS } from "../../../components/GraphQL/Queries";
import { useQuery } from "@apollo/client";
import { toast } from "react-toastify";
import fallBackImage from "../../../asset/img/fallback-station-img.jpeg";
import { SpinnerContainer, Spinner } from "./components";
import { ReactComponent as FilterIcon } from "../../../assets/icons/filter.svg";
import mixpanel from "mixpanel-browser";
import { CancelIcon } from "../Svg";
// import radioStation from "../../../assets/radioStation.png";

const RecommendedStation = ({
  countrystateobj,
  searchState,
  location,
  checkBox,
  setCheckBox,
  countrystatename,
  filterByPriceRange,
  currency,
  isSearching,
  search,
  broadcasterData,
  setBroadcasterData,
}) => {
  const [selectedStation, setSelectedStation] = useState([]);
  const [clearSelect, setClearSelect] = useState(false);
  const [check, setCheck] = useState(false);
  const [limit, setLimit] = useState(50);
  const [hasMore, setHasMore] = useState(true);

  const navigate = useNavigate();

  localStorage.removeItem(checkBox);

  let selectStation = (data) => {
    setSelectedStation([...selectedStation, data]);
    setClearSelect(true);
  };

  let deSelectStation = (data) => {
    setSelectedStation(selectedStation?.filter((a) => a.id !== data.id));
  };

  const { data, loading, fetchMore, refetch } = useQuery(GET_BROADCASTERS, {
    variables: {
      page: 1,
      itemsPerPage: limit,
      currency,
      radioSationName: search,
      state: countrystatename?.stateName,
      country: countrystatename?.country,
    },
    notifyOnNetworkStatusChange: true, // Allows tracking of loading states
  });

  useEffect(() => {
    if (searchState === true) {
      return setBroadcasterData(data?.guest?.getBroadcasters?.broadcasters);
    }
    if (countrystatename?.isSearch === true) {
      return setBroadcasterData(data?.guest?.getBroadcasters?.broadcasters);
    }
    if (location.length) {
      const broadcasterArray =
        data?.guest?.getBroadcasters?.broadcasters?.filter(({ state }) =>
          location.includes(state)
        );
      return setBroadcasterData(broadcasterArray);
    } else {
      return setBroadcasterData(data?.guest?.getBroadcasters?.broadcasters);
    }
  }, [
    searchState,
    data,
    countrystateobj,
    location,
    currency,
    countrystatename?.stateName,
    countrystatename?.country,
  ]);

  // Refetch the query whenever search or country/state changes
  useEffect(() => {
    if (search || countrystatename.stateName || countrystatename.countryName) {
      refetch({
        radioSationName: search,
        state: countrystatename.stateName,
        country: countrystatename.countryName,
        currency,
      });
    }
  }, [search, countrystatename, currency, refetch]);

  useEffect(() => {
    localStorage.removeItem("selectedStations");
    localStorage.removeItem("currency");
    setCheckBox([]);
  }, []);

  //clear selected stations
  const maxCount = broadcasterData?.filter(
    (broadcaster) => broadcaster?.isApproved
  ).length;

  const loadMore = () => {
    fetchMore({
      variables: {
        page: 1,
        itemsPerPage: limit + 50,
        state: countrystatename?.stateName,
        country: countrystatename?.country,
        currency,
      },
    }).then((fetchMoreResult) => {
      const newData = fetchMoreResult.data.guest.getBroadcasters.broadcasters;
      setLimit((prevLimit) => prevLimit + 50);
      setBroadcasterData(newData);

      // Check if more data is available
      if (newData.length < limit + 50) {
        setHasMore(false);
      }
    });
  };

  const showLess = () => {
    setLimit(50);
    fetchMore({
      variables: {
        page: 1,
        itemsPerPage: 50,
        state: countrystatename?.stateName,
        country: countrystatename?.country,
        currency,
      },
    }).then((fetchMoreResult) => {
      setBroadcasterData(
        fetchMoreResult.data.guest.getBroadcasters.broadcasters
      );
      setHasMore(true); // Reset hasMore when showing less
    });
  };
  const clearStations = () => {
    if (clearSelect === false) {
      localStorage.removeItem("selectedStations");
      setClearSelect(true);
      setCheckBox([]);
    } else {
      setClearSelect(false);
    }
    setTimeout(() => {
      setClearSelect(false);
    }, 1000);
  };

  const selectedRadioStations = localStorage.getItem("selectedStations") ?? "";
  const getSelectedStations = selectedRadioStations
    ? selectedRadioStations.split(",")
    : [];

  const filteredData = broadcasterData?.filter((item) => {
    return getSelectedStations.includes(item?.id);
  });

  const handleBooking = () => {
    // track user event
    mixpanel.track("select_radio_sations");

    if (!checkBox.length) {
      return toast.error("you've not select a radio station");
    } else {
      // navigate(`/book-campaign/campaign-details?stations=${checkBox}`);
      localStorage.setItem("currency", currency);
      navigate(`/book-campaign/campaign-details`);
    }
  };

  const handleCheck = (id) => {
    // console.log("id--", id);
    let mutatedSelectedStation = selectedRadioStations.length
      ? [...selectedRadioStations.split(",")]
      : [];

    // Always remove the ID from checkBox and mutatedSelectedStation
    const updatedCheckBox = checkBox.filter((station) => station !== id);
    setCheckBox(updatedCheckBox);
    mutatedSelectedStation = mutatedSelectedStation.filter(
      (station) => station !== id
    );

    if (mutatedSelectedStation.length) {
      localStorage.setItem(
        "selectedStations",
        mutatedSelectedStation.join(",")
      );
    } else {
      localStorage.removeItem("selectedStations");
    }
  };

  // console.log("broadcasterData", broadcasterData);
  return (
    <div id="recommended-station">
      {/* <div>
        <div>
          <h2>Radio Stations</h2>
        </div>

        {/* INPUT FILEDS */}
      <div></div>

      {/* END OF INPUT FIELDS */}
      {/* </div> */}
      {/* <div id="recommended-bar"></div> */}

      <div>
        <div id="filter-station-ctrl"></div>
        {!loading && !isSearching ? (
          <div id="recommended-station-list">
            {broadcasterData?.filter(
              (broadcaster) => broadcaster.isApproved === true
            ).length > 0 ? (
              <div>
                {broadcasterData
                  ?.filter((broadcaster) => broadcaster.isApproved === true)
                  // .slice(0, visibleDataCount)
                  .map((station, index) => {
                    return (
                      <Station
                        key={station.id}
                        id={station.id}
                        img={station.banner ?? fallBackImage}
                        name={station.name}
                        currency={station?.currency}
                        startingPrice={station?.startingPrice}
                        discountedStatingPrice={station.discountedStatingPrice}
                        discountPercentage={station.discountPercentage}
                        clearSelect={clearSelect}
                        select={selectStation}
                        deSelect={deSelectStation}
                        setCheckBox={setCheckBox}
                        checkBox={checkBox}
                        check={check}
                        setCheck={setCheck}
                      />
                    );
                  })}
              </div>
            ) : (
              <div className="not-found">
                <p>No Verified Data available</p>
              </div>
            )}
          </div>
        ) : (
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        )}
      </div>
      <div>
        <div id="recommendation_load">
          {hasMore && (
            <button type="button" onClick={loadMore}>
              LOAD MORE
            </button>
          )}
          {!hasMore && limit > 50 && (
            <button onClick={showLess}>SHOW LESS</button>
          )}
        </div>
        {/* <button className="book_now_btn" onClick={handleBooking}>
          Book Now
        </button> */}
      </div>

      {/* FIXED FOOTER */}

      {filteredData?.length > 0 && (
        <div id="recommedation_footer_fixed">
          <div id="recommendation_clear">
            <button onClick={clearStations}>Clear all</button>
          </div>

          <div id="recommendation_body">
            <div id="recommendation_footer_content">
              {/* SELECTED RADIO STATIONS */}
              {filteredData?.length !== 0 &&
                filteredData?.map((station, index) => {
                  return (
                    <div id="footer_pic" key={station?.id}>
                      <div id="img_wrapper">
                        <div id="radiostation_img">
                          <img
                            src={station?.banner ?? fallBackImage}
                            alt="selected_station"
                          />
                        </div>
                        <div
                          id="cancel_icon"
                          onClick={() => handleCheck(station?.id)}
                        >
                          <CancelIcon />
                        </div>
                      </div>
                      <div>
                        <p id="img_text">{station?.name?.split(" ")[0]}</p>
                      </div>
                    </div>
                  );
                })}
              {/* END OF SELECTED RADIO STATIONS */}
            </div>
            <div id="book_now_wrapper">
              <button id="book_now_btn" onClick={handleBooking}>
                Book Now
              </button>
            </div>
          </div>
        </div>
      )}

      {/* END OF FIXED FOOTER */}
    </div>
  );
};

export default RecommendedStation;
